import React, { useEffect, useState } from 'react'
import { FiCopy, FiX, FiTrendingUp, FiCheckCircle } from 'react-icons/fi';
import { FaWallet } from 'react-icons/fa';

import DetailsCopier from './components/DetailsCopier'

import { getAgentResultsService } from '../../services/result.service';
import { useDispatch } from 'react-redux';
import { setToastMessage } from '../../reducers/common.reducer';


const ResultCopy = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [onClose, setOnClose] = useState(false)
    const [showOverAll, setShowOverAll] = useState(false)
    const [resultData, setResultData] = useState([]);
    const [fromDateToDate, setFromDateToDate] = useState("")
    const [agentDetailData, setAgentDetailData] = useState({});
    const [selectedIndex, setSelectedIndex] = useState(null);

    let dispatch = useDispatch();

    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed, so we add 1
    let day = String(currentDate.getDate()).padStart(2, '0');

    let formattedDate = `${year}-${month}-${day}`;
    const [date, setDate] = useState(formattedDate);

    const handleShowOverAll = () => {
        setShowOverAll(!showOverAll)
    }

    async function getAgentResult() {
        try {
            setIsLoading(true)
            let result = await getAgentResultsService(date)
            if (result.data) {
                setResultData(result.data)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getAgentResult();
    }, [date])


    const overallTotals = resultData && resultData.reduce((acc, agent) => {
        acc.totalWinLoss += Math.round(1 * agent.winLoss);
        acc.totalRemain += Math.round(1 * agent.remain - agent.winLoss);
        acc.totalFinal += Math.round(1 * agent.remain);
        return acc;
    }, { totalWinLoss: 0, totalRemain: 0, totalFinal: 0 });



    return (
        <div>
            <div className='flex justify-center items-center w-full mx-auto h-[90vh] bg-slate-200 text-sm font-mono font-bold'>
                <div
                    className='h-[87vh] max-w-7xl w-full mx-auto'
                    onClick={(e) => e.stopPropagation()} >
                    <div className='bg-white text-gray-700 rounded-md p-1'>
                        <div className='relative flex justify-start items-center w-full h-24 sm:h-16 px-4 bg-white text-gray-700 rounded-md mb-2'>
                            <div className='flex flex-col sm:flex-row justify-center sm:justify-start items-start sm:items-center'>
                                <input
                                    type="date"
                                    value={date}
                                    className='ms-2 text-gray-700 outline-none bg-[#eef2f6] py-1.5 px-4 w-48 rounded-md mb-2 sm:mb-0'
                                    onChange={(e) => setDate(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder='Day. 10/09 to 12/09'
                                    className='mx-2 text-gray-700 outline-none bg-[#eef2f6] py-1.5 px-4 w-48 rounded-md mb-2 sm:mb-0'
                                    onChange={(e) => setFromDateToDate(e.target.value)}
                                />
                            </div>
                            <div className=''>
                                <button onClick={handleShowOverAll} className="flex items-center gap-2 ms-2 bg-buttonBlue text-white py-1.5 px-4 rounded-md">
                                    Show Overall
                                </button>
                            </div>
                        </div>
                        <div className='max-h-[75vh] overflow-y-auto overscroll-contain overflow-hidden'>
                            {resultData && resultData.length > 0 ? (
                                <table className='w-full'>
                                    <thead className='sticky top-0 bg-slate-100 rounded-t-md uppercase tracking-wider'>
                                        <tr>
                                            <th className="px-4 py-3 w-6 sm:w-16 text-center hidden sm:block" scope="col">No.</th>
                                            <th className="px-4 py-3" scope="col">Agent</th>
                                            <th className="px-4 py-3 text-center" scope="col">Remain</th>
                                            <th className="px-4 py-3 text-center" scope="col">Total</th>
                                            <th className="px-4 py-3 text-center" scope="col">Final</th>
                                            <th className="px-4 py-3 text-center" scope="col">View</th>
                                        </tr>
                                    </thead>
                                    <tbody className=''>
                                        {resultData.map((result, index) => (
                                            <tr className={`h-12 border-b border-dashed cursor-pointer hover:bg-slate-100 ${selectedIndex === index ? 'bg-indigo-50' : ''}`}
                                                key={result.id}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setOnClose(true)
                                                    setAgentDetailData(result)
                                                    setSelectedIndex(index)
                                                }}>
                                                <td className='px-4 py-2 w-6 sm:w-16 text-center hidden sm:block'>{index + 1}</td>
                                                <td className='px-4 py-2 text-center text-gray-900'>{result.agentName}</td>
                                                <td className='px-4 py-2 text-center'>
                                                    {Math.round(result.remain - result.winLoss)}
                                                </td>
                                                <td className='px-4 py-2 text-center'>
                                                    {Math.round(result.winLoss)}
                                                </td>
                                                <td className='px-4 py-2 text-center'>
                                                    {Math.round(result.remain)}
                                                </td>
                                                <td className='align-middle px-4 py-2'>
                                                    <div className='flex justify-center items-center'>
                                                        <FiCopy
                                                            size={16}
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                setOnClose(true)
                                                                setAgentDetailData(result)
                                                                setSelectedIndex(index)
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                !isLoading && (
                                    <div className='flex justify-center items-center h-[75vh]'>
                                        <h1 className='text-lg text-slate-300 underline'>» No Data Found «</h1>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>

                {showOverAll && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center p-6">
                        {/* Clean Backdrop */}
                        <div
                            className="absolute inset-0 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200"
                            onClick={() => setShowOverAll(false)}
                        />

                        {/* Small Compact Modal */}
                        <div className="relative w-full max-w-[350px] bg-white rounded-2xl shadow-xl overflow-hidden animate-in zoom-in-95 duration-200">

                            {/* Minimal Header */}
                            <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
                                <h2 className="text-[13px] font-bold text-gray-700 uppercase tracking-wider">Summary</h2>
                                <button
                                    onClick={() => setShowOverAll(false)}
                                    className="text-gray-400 hover:text-gray-600 p-1"
                                >
                                    <FiX size={16} />
                                </button>
                            </div>

                            {/* Compact Body */}
                            <div className="px-6 py-4 space-y-3">

                                {/* Row 1: Remain */}
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 rounded-full bg-blue-500" />
                                        <span className="text-[13px] text-gray-500">Remain</span>
                                    </div>
                                    <span className="text-sm font-bold text-gray-800">
                                        {overallTotals?.totalRemain?.toLocaleString()}
                                    </span>
                                </div>

                                {/* Row 2: Win/Loss */}
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center gap-2">
                                        <div className={`w-2 h-2 rounded-full ${overallTotals?.totalWinLoss >= 0 ? 'bg-red-500' : 'bg-emerald-500'}`} />
                                        <span className="text-[13px] text-gray-500">Win/Loss</span>
                                    </div>
                                    <span className={`text-sm font-bold ${overallTotals?.totalWinLoss >= 0 ? 'text-red-500' : 'text-emerald-500'}`}>
                                        {Math.round(overallTotals?.totalWinLoss)?.toLocaleString()}
                                    </span>
                                </div>

                                {/* Divider */}
                                <div className="h-[1px] bg-dashed bg-gray-200 border-t border-dashed" />

                                {/* Row 3: Total Final (Focus) */}
                                <div className="flex justify-between items-center pt-1">
                                    <span className="text-sm font-extrabold text-indigo-600">Total Final</span>
                                    <span className="text-lg font-black text-indigo-700">
                                        {Math.round(overallTotals?.totalFinal)?.toLocaleString()}
                                    </span>
                                </div>

                                {/* Action Button */}
                                <button
                                    onClick={() => setShowOverAll(false)}
                                    className="w-full mt-2 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-[13px] font-bold transition-all active:scale-[0.97]"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {onClose && (
                    <DetailsCopier
                        onClose={() => setOnClose(false)}
                        date={date}
                        agentDetailData={agentDetailData}
                        fromDateToDate={fromDateToDate}
                    />
                )}
            </div>
        </div>
    )
}

export default ResultCopy
